import type { SystemOption } from './types'

export const SYSTEM_OPTIONS: SystemOption[] = [
  { value: 'mes', label: 'MES', description: '制造执行' },
  { value: 'system', label: 'SYSTEM', description: '系统管理' },
  { value: 'wms', label: 'WMS', description: '仓储管理' },
  { value: 'qms', label: 'QMS', description: '质量管理' },
]

export const DEFAULT_QUERY_URL = '/system/table-config/query'

/** 构建数据源路径：/mes/custom */
export function buildDataSourcePath(system: string, dataSourceFlag: string) {
  return `/${system.trim()}/${dataSourceFlag.trim()}`
}

/** 解析 /mes/custom → { system, dataSourceFlag } */
export function parseDataSourcePath(path: string) {
  const normalized = path.trim().replace(/^\/+|\/+$/g, '')
  const slash = normalized.indexOf('/')
  if (slash <= 0 || slash >= normalized.length - 1) {
    throw new Error(
      '数据源路径格式应为 /systemFlag/dataSourceFlag，例如 /mes/custom'
    )
  }
  return {
    system: normalized.slice(0, slash),
    dataSourceFlag: normalized.slice(slash + 1),
  }
}
